import { render } from "./UpdateWidgetPopup.vue?vue&type=template&id=a0edfaac&scoped=true&ts=true"
import script from "./UpdateWidgetPopup.vue?vue&type=script&lang=ts"
export * from "./UpdateWidgetPopup.vue?vue&type=script&lang=ts"

import "./UpdateWidgetPopup.vue?vue&type=style&index=0&id=a0edfaac&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0edfaac"]])

export default __exports__